(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fw-video-sound"] && !Shopify.designMode) return;
  try {
    function syncVideoSound(video){
  const button=video.parentElement.querySelector('[data-fw-video-sound]');
  if(!button)return;
  const soundOn=!video.muted&&video.volume>0;
  button.setAttribute('aria-pressed',String(soundOn));
  button.textContent=soundOn?button.dataset.soundOff:button.dataset.soundOn;
}
document.addEventListener('click',function(event){
  const button=event.target.closest('[data-fw-video-sound]');
  if(!button)return;
  const video=button.parentElement.querySelector('video');
  if(!video)return;
  const enableSound=video.muted||video.volume===0;
  if(enableSound){
    video.removeAttribute('muted');
    video.muted=false;
    video.volume=1;
    const playing=video.play();
    if(playing&&playing.catch)playing.catch(function(){
      if(video.paused)video.muted=true;
      syncVideoSound(video);
    });
  }else{
    video.muted=true;
  }
  syncVideoSound(video);
});
document.addEventListener('volumechange',function(event){
  if(event.target instanceof HTMLVideoElement)syncVideoSound(event.target);
},true);
  } catch(e) { console.error(e); }
})();

})();
